import { generateContainerQueries } from 'shared-utils'

export const CALENDAR_RESPONSIVE_CONTAINER = 'ui_calendar_responsive_container'

export const CALENDER_QUERIES = generateContainerQueries(
	CALENDAR_RESPONSIVE_CONTAINER,
)
